export default __webpack_public_path__ + "static/media/Button-carousel-left.35bcfa67.svg";